import React from 'react';
import { get, map, isUndefined } from 'lodash';

// local dependencies
import { useState } from 'react';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
import { radioBox as RadioBox } from 'ui/views/generic/radioBox';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { deactiveEpostConfirmation as DeactiveEpostConfirmation } from 'ui/views/widgets/deactiveEpostConfirmation';
 *
 * // render
 * <DeactiveEpostConfirmation propName='propValue'/>
 */
export const deactiveEpostConfirmation = ( props ) => {

    const [ selectedVal, setReason ] = useState( undefined );
   console.log(props)

    return (
        <div className='ui-deactive-epost-confirmation'>
            
            <div className='ui-deactive-epost-confirmation__header'>

                {/* title for the modal */}
                <div className='ui-deactive-epost-confirmation__header__title'>
                    { getLabel( props.title ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>

            <div className='ui-deactive-epost-confirmation__body'>

                <div className='ui-deactive-epost-confirmation__body__subtitle'> { getLabel( props.subtitle ) } </div>

                { map( get( props, 'reasonType', [] ), option => {
                    return(
                        <div key={ option.value } className='ui-deactive-epost-confirmation__body__options' onClick={ () => setReason( option.value ) }>
                            <RadioBox
                                name={ option.name }
                                value={ option.value }
                                selected={ option.value === selectedVal }
                            />
                            <span className='ui-deactive-epost-confirmation__body__options__text'>{ getLabel( option.title ) }</span>
                        </div>
                    );
                } ) }
                <div  className='ui-deactive-epost-confirmation__body__message'>{getLabel(props.message)}</div>
            </div>

            {/* actions */}
            <div className='ui-deactive-epost-confirmation__actions'>
                { map( props.actions, action => {

                    let disabled = false;

                    if( 'cancel' !== action.name ) {
                        disabled = isUndefined( selectedVal );
                    }

                    return (
                        <Button
                            key={ action.name }
                            { ...action }
                            size='medium'
                            className='ui-deactive-epost-confirmation__actions__action'
                            outline={ 'cancel' === action.name ? true: false }
                            disabled={ disabled }
                            onClick={ 'cancel' === action.name ? () => props.closeOverlay(): () => props.onSumbitAction( selectedVal ) }
                        />
                    );
                } ) }
            </div>


        </div>
    );
};

// set display name
deactiveEpostConfirmation.displayName = 'deactiveEpostConfirmation';

// set default props
deactiveEpostConfirmation.defaultProps = {};

// prop types
deactiveEpostConfirmation.propTypes = {};
